import ServicesHero from './components/ServicesHero';
import ServicesDetail from './components/ServicesDetail';
import CTASection from '@/pages/home/components/CTASection';
import SEO from '@/components/feature/SEO';

const ServicesPage = () => {
  return (
    <main>
      <SEO 
        title="Nuestros Servicios | Sbdigisolutions" 
        description="Descubre cómo nuestros servicios de marketing digital, branding y automatización pueden llevar tu negocio al siguiente nivel." 
      />
      <ServicesHero />
      <ServicesDetail />
      <CTASection />
    </main>
  );
};

export default ServicesPage;
